import bitcoin_block from '../../assets/bitcoin_block.png';
import ethereum_block from '../../assets/ethereum_block.png';
import binance_block from '../../assets/binance_block.png';
import solana_block from '../../assets/solana_block.png';
import tether_block from '../../assets/tether_block.png';
import litecoin_block from '../../assets/litecoin_block.png';
import tron_block from '../../assets/tron_block.png';

import bitcoin from '../../assets/bitcoin.png';
import ethereum from '../../assets/ethereum.png';
import binance from '../../assets/binance.png';
import solana from '../../assets/solana.png';
import tether from '../../assets/tether.png';
import litecoin from '../../assets/litecoin.png';
import tron from '../../assets/tron.png';

// Used for the "which blockchains does this plan include" list on the Dashboard page
export const BLOCKCHAIN_ICONS = {
  bitcoin: bitcoin_block,
  ethereum: ethereum_block,
  binance: binance_block,
  solana: solana_block,
  tether: tether_block,
  litecoin: litecoin_block,
  tron: tron_block,
};

// Used for found-wallet stats (breakdown chart, latest find, recent finds list)
const SYMBOL_ICONS = {
  BTC: bitcoin,
  ETH: ethereum,
  BNB: binance,
  SOL: solana,
  USDT: tether,
  LTC: litecoin,
  TRX: tron,
};

export const getIconForSymbol = (symbol) => SYMBOL_ICONS[symbol] || null;
